import BeerList from './components/BeerList';


function App() {
  return (
    <div>
      <BeerList />
    </div>
  );
}

export default App;
